import auth from "@/helper/middleware/auth";
export default [
  {
    path: "/settings",
    name: "settings",
    component: () => import("@/views/settings/SettingsView.vue"),
    redirect: { name: "profileSetting" },
    meta: { middleware: [auth] },
    children: [
      {
        path: "profile",
        name: "profileSetting",
        component: () => import("@/views/settings/ProfileView.vue"),
      },
      {
        path: "e-signature",
        name: "eSignatureSetting",
        component: () => import("@/views/settings/ESignatureView.vue"),
      },
      {
        path: "signature",
        name: "signatureSetting",
        component: () => import("@/views/settings/SignatureView.vue"),
      },
      {
        path: "paraf",
        name: "parafSetting",
        component: () => import("@/views/settings/ParafView.vue"),
      },
      {
        path: "password",
        name: "passwordSetting",
        component: () => import("@/views/settings/PasswordView.vue"),
      },
      {
        path: "pin",
        name: "pinSetting",
        component: () => import("@/views/settings/PinView.vue"),
      },
      {
        path: "passphare",
        name: "passphareSetting",
        component: () => import("@/views/settings/PassphareView.vue"),
      },
    ],
  },
];
